import { render, staticRenderFns } from "./epoca-alvo.vue?vue&type=template&id=37874f98&"
import script from "./epoca-alvo.vue?vue&type=script&lang=js&"
export * from "./epoca-alvo.vue?vue&type=script&lang=js&"
import style0 from "./epoca-alvo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports